export let emojiDictionary = {
  "💘": "Heart with Arrow",
  "💝": "Heart with Ribbon",
  "💖": "Sparkling Heart",
  "💗": "Growing Heart",
  "💓": "Beating Heart",
  "💞": "Revolving Hearts",
  "💕": "Two Hearts",
  "💟": "Heart Decoration",
  "❣": "Heart Exclamation",
  "💔": "Broken Heart",
  "🧡": "Orange Heart",
  "💛": "Yellow Heart",
  "💚": "Green Heart",
  "💙": "Blue Heart",
  "💜": "Purple Heart",
  "🤎": "Brown Heart",
  "🖤": "Black Heart",
  "🤍": "White Heart",
  "💯": "Hundred Points",
  "💢": "Anger Symbol",
  "💬": "Speech Balloon",
  "👁️‍🗨️": "Eye in Speech Bubble",
  "🗨️": "Left Speech Bubble",
  "🗯️": "Right Anger Bubble",
  "💭": "Thought Balloon",
  "💤": "Zzz",
  "💮": "White Flower",
  "💈": "Barber Pole",
  "🛑": "Stop Sign",
  "🕛": "Twelve O’Clock",
  "🕧": "Twelve-Thirty",
  "🕐": "One O’Clock",
  "🕜": "One-Thirty",
  "🕑": "Two O’Clock",
  "🕝": "Two-Thirty",
  "🕒": "Three O’Clock",
  "🕞": "Three-Thirty",
  "🕓": "Four O’Clock",
  "🕟": "Four-Thirty",
  "🕔": "Five O’Clock",
  "🕠": "Five-Thirty",
  "🕕": "Six O’Clock",
  "🕡": "Six-Thirty",
  "🕖": "Seven O’Clock",
  "🕢": "Seven-Thirty",
  "🕗": "Eight O’Clock",
  "🕣": "Eight-Thirty",
  "🕘": "Nine O’Clock",
  "🕤": "Nine-Thirty",
  "🕙": "Ten O’Clock",
  "🕥": "Ten-Thirty",
  "🕚": "Eleven O’Clock",
  "🕦": "Eleven-Thirty",
  "🌀": "Cyclone",
  "♠️": "Spade Suit",
  "♥️": "Heart Suit",
  "♦️": "Diamond Suit",
  "♣️": "Club Suit",
  "🃏": "Joker",
  "🀄": "Mahjong Red Dragon",
  "🎴": "Flower Playing Cards",
  "🔇": "Muted Speaker",
  "🔈": "Speaker Low Volume",
  "🔉": "Speaker Medium Volume",
  "🔊": "Speaker High Volume",
  "📢": "Loudspeaker",
  "📣": "Megaphone",
  "📯": "Postal Horn",
  "🔔": "Bell",
  "🔕": "Bell with Slash",
  "🎵": "Musical Note",
  "🎶": "Musical Notes",
  "💹": "Chart Increasing with ",
  "🏧": "ATM Sign",
  "🚮": "Litter in Bin Sign",
  "🚰": "Potable Water",
  "♿": "Wheelchair Symbol",
  "🚹": "Mens Room",
  "🚺": "Women’s Room",
  "🚻": "Restroom",
  "🚼": "Baby Symbol",
  "🚾": "Water Closet",
  "🚸": "Children Crossing",
  "⛔": "No Entry",
  "🚫": "Prohibited",
  "🚳": "No Bicycles",
  "🚭": "No Smoking",
  "🚯": "No Littering",
  "🚱": "Non-Potable Water",
  "🚷": "No Pedestrians",
  "📵": "No Mobile Phones",
  "🔞": "No One Under Eighteen",
  "↗️": "Up-Right Arrow",
  "➡️": "Right Arrow",
  "↕️": "Up-Down Arrow",
  "↔": "Left-Right Arrow",
  "↪": "Left Arrow Curving Right",
  "⤵": "Right Arrow Curving Down",
  "🔃": "Clockwise Vertical Arrows",
  "🔄": "Counterclockwise Arrows Button",
  "🔙": "Back Arrow",
  "🔚": "End Arrow",
  "🔛": "On! Arrow",
  "🔜": "Soon Arrow",
  "🔝": "Top Arrow",
  "☸️": "Wheel of Dharma",
  "🕉️": "Om",
  "☯️": "Yin Yang",
  "✝️": "Latin Cross",
  "☦️": "Orthodox Cross",
  "☪️": "Star and Crescent",
  "☮️": "Peace Symbol",
  "🕎": "Menorah",
  "🔯": "Dotted Six-Pointed Star",
  "♈": "Aries",
  "♉": "Taurus",
  "♊": "Gemini",
  "♋": "Cancer",
  "♌": "Leo",
  "♍": "Virgo",
  "♎": "Libra",
  "♏": "Scorpio",
  "♐": "Sagittarius",
  "♑": "Capricorn",
  "♒": "Aquarius",
  "♓": "Pisces",
  "⛎": "Ophiuchus",
  "🔀": "Shuffle Tracks Button",
  "🔁": "Repeat Button",
  "🔂": "Repeat Single Button",
  "⏩": "Fast-Forward Button",
  "⏭️": "Next Track Button",
  "◀️": "Reverse Button",
  "⏪": "Fast Reverse Button",
  "⏮": "Last Track Button",
  "🔼": "Upwards Button",
  "⏫": "Fast Up Button",
  "🔽": "Downwards Button",
  "⏬": "Fast Down Button",
  "⏸️": "Pause Button",
  "🎦": "Cinema",
  "🔅": "Dim Button",
  "🔆": "Bright Button",
  "📶": "Antenna Bars",
  "📳": "Vibration Mode",
  "📴": "Mobile Phone Off",
  "➕": "Plus",
  "➖": "Minus",
  "➗": "Divide",
  "❓": "Question Mark",
  "❔": "White Question Mark",
  "❕": "White Exclamation Mark",
  "❗": "Exclamation Mark",
  "〰️": "Wavy Dash",
  "💱": "Currency Exchange",
  "💲": "Heavy Dollar Sign",
  "⚜": "Fleur-de-lis",
  "🔱": "Trident Emblem",
  "📛": "Name Badge",
  "🔰": "Japanese Symbol for Beginner",
  "⭕": "Hollow Red Circle",
  "✅": "Check Mark Button",
  "❌": "Cross Mark",
  "❎": "Cross Mark Button",
  "➰": "Curly Loop",
  "➿": "Double Curly Loop",
  "〽️": "Part Alternation Mark",
  "™️": "Trade Mark",
  "🆑": "CL Button",
  "🆒": "Cool Button",
  "🆓": "Free Button",
  ℹ: "Information",
  "🆔": "ID Button",
  "🆕": "New Button",
  "🆖": "NG Button",
  "🅿️": "P Button",
  "🆘": "SOS Button",
  "🆙": "Up! Button",
  "🆚": "Vs Button",
  "🈁": "Japanese “Here” Button",
  "🈂️": "Japanese “Service Charge” Button",
  "🈷️": "Japanese “Monthly Amount” Button",
  "🈶": "Japanese “Not Free of Charge” Button",
  "🈯": "Japanese “Reserved” Button",
  "🉐": "Japanese “Bargain” Button",
  "🈹": "Japanese “Discount” Button",
  "🈚": "Japanese “Free of Charge” Button",
  "🈲": "Japanese “Prohibited” Button",
  "🉑": "Japanese “Acceptable” Button",
  "🈸": "Japanese “Application” Button",
  "🈴": "Japanese “Passing Grade” Button",
  "🈳": "Japanese “Vacancy” Button",
  "㊗️": "Japanese “Secret” Button",
  "🈺": "Japanese “Open for Business” Button",
  "🈵": "Japanese “No Vacancy” Button",
  "🔴": "Red Circle",
  "🟠": "Orange Circle",
  "🟡": "Yellow Circle",
  "🟢": "Green Circle",
  "🔵": "Blue Circle",
  "🟤": "Brown Circle",
  "⚫": "Black Circle",
  "⚪": "White Circle",
  "🟥": "Red Square",
  "🟧": "Orange Square",
  "🟨": "Yellow Square",
  "🟩": "Green Square",
  "🟦": "Blue Square",
  "🟪": "Purple Square",
  "🟫": "Brown Square",
  "⬛": "Black Large Square",
  "⬜": "White Large Square",
  "◻": "White Medium Square",
  "◾": "Black Medium-Small Square",
  "◽": "White Medium-Small Square",
  "▫": "White Small Square",
  "🔶": "Large Orange Diamond",
  "🔷": "Large Blue Diamond",
  "🔸": "Small Orange Diamond",
  "🔹": "Small Blue Diamond",
  "🔺": "Red Triangle Pointed Up",
  "🔻": "Red Triangle Pointed Down",
  "💠": "Diamond with a Dot",
  "🔘": "Radio Button",
  "🔳": "White Square Button"
};
